import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ApplicationTemplate, NavItem } from '@uni-space/uni-components';
import navConfig from './routes/navigationConfig.tsx';
import { keycloak } from '@shared/config/KeycloakConfig.tsx';
import { filterNavItemsByParentAccess, useUserCredentials } from '@shared/utils/auth.tsx';
import { PrinterSidebarPortal } from '@widgets/PrinterConnection';
import './appTemplateOverrides.scss';

export default function Application() {
  const { t } = useTranslation();
  const location = useLocation();
  const { roles, hasRoleAccessAny } = useUserCredentials();
  const allowedNav = filterNavItemsByParentAccess(navConfig, roles, hasRoleAccessAny);

  return (
    <>
      <ApplicationTemplate onExit={() => keycloak?.logout()} t={t} navItems={allowedNav as NavItem[]} location={location}>
        <Outlet />
      </ApplicationTemplate>
      <PrinterSidebarPortal />
    </>
  );
}
